import {
  LitElement,
  html,
  nothing
} from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import ButtonGroupToggleStyle from './style.js';
import ButtonClearStyle from '../Common/ButtonClearStyle.js';
import dedent from '../../util/dedent.js';
import LdsIcon from '../LdsIcon/index.js';

export class LdsButtonGroupToggle extends LitElement {
  static get styles() {
    return [ButtonClearStyle, ButtonGroupToggleStyle];
  }

  static properties = {
    isOpen: { type: Boolean },
    isSplit: { type: Boolean },
    disabled: { type: Boolean },
    dropdownId: { type: String },
    iconName: { type: String },
  };

  constructor() {
    super();
    this.isOpen = false;
    this.isSplit = false;
    this.disabled = false;
    this.dropdownId = undefined;
    this.iconName = undefined;
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('click', (e) => this.handleDocumentClick(e));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', (e) => this.handleDocumentClick(e));
  }

  handleToggle() {
    this.isOpen = !this.isOpen;
    this.setDropDownOpenHeight();
  }

  handleDocumentClick(e) {
    if (!e.composedPath().includes(this)) {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    this.isOpen = false;
    this.setDropDownOpenHeight();
  }

  getOverflowIconName() {
    let icon;
    if (this.isSplit) {
      icon = 'CaretDownFill';
    } else if (this.iconName) {
      icon = this.iconName;
    } else {
      icon = 'DotsThreeOutlineFill';
    }
    return icon;
  }

  getAriaControlsId() {
    return this.dropdownId ? `${this.dropdownId}-overflowpanel` : '99-overflowpanel';
  }

  setDropDownOpenHeight() {
    if (!this.dropdownId) {
      // eslint-disable-next-line
      console.error(dedent`
        LdsButtonGroupToggle - Error
        Prop 'dropdownId' must be set for Button Group with overflow to function correctly.
      `);
      return;
    }
    const dropdown = document.getElementById(this.dropdownId);
    const dropdownBody = document.querySelector(`#${this.dropdownId} .lds-button-group-dropdown`);

    if (dropdown !== null && dropdownBody !== null) {
      dropdownBody.id = this.getAriaControlsId();
      if (this.isOpen) {
        dropdown.classList.add('open');
        dropdownBody.style.maxHeight = `${dropdownBody.scrollHeight}px`;
      } else {
        dropdown.classList.remove('open');
        dropdownBody.style.maxHeight = 0;
      }
    }
  }

  render() {
    return html`
      <button
        @click=${this.handleToggle}
        class="lds-button-clear-style lds-button-group-toggle-btn"
        disabled="${this.disabled ? 'disabled' : nothing}"
        aria-expanded=${this.isOpen}
        aria-controls=${this.getAriaControlsId()}
        aria-label="Show more options"
      >
        <lds-icon
          name="${this.getOverflowIconName()}"
          class="button-icon ${classMap({ 'split-icon': this.isSplit, open: this.isOpen })}"
          inline
          decorative
        ></lds-icon>
      </button>
    `;
  }
}

export function defineComponent() {
  if (!window.customElements.get('lds-button-group-toggle')) window.customElements.define('lds-button-group-toggle', LdsButtonGroupToggle);
  LdsIcon.defineComponent();
}

export default { LdsButtonGroupToggle, defineComponent };
